/* eslint-disable */
import CloseIcon from '@mui/icons-material/Close'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import { InfoWindow } from '@react-google-maps/api'
import React, { useEffect, useRef, useState } from 'react'
import ApiService from '../../../../ApiService.js'
import { useStates } from '../../../../StateProvider.js'
import { TRIP_STOPS_DELETE_URL } from '../../../../constants.js'
import { useEmulatorStore } from '../../../../stores/emulator/store.tsx'
import './selectedStopInfo.scss'
// import { toHumanReadableTime } from './utils.tsx'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

export function SelectedBreakInfo(props) {
  dayjs.extend(utc)
  dayjs.extend(timezone)
  const { showToast } = useStates()
  const [deleteStopsShow, setDeleteStopsShow] = useState(false)
  const connectedEmulatorRef = useRef(
    useEmulatorStore.getState().connectedEmulator
  )
  const tripDataRef = useRef(useEmulatorStore.getState().tripData)
  const [distanceFromStartToStops, setDistanceFromStartToStops] = useState(null)
  const [timeToReachThisStop, setTimeToReachThisStop] = useState(null)
  const [tripResumeTime, setTripResumeTime] = useState(null)
  const [remainingDistanceToThisStop, setRemainingDistanceToThisStop] = useState(null)
  useEffect(
    () =>
      useEmulatorStore.subscribe(
        (state) => state.connectedEmulator,
        (connectedEmulator) => {
          connectedEmulatorRef.current = connectedEmulator
          updateStopWindowInfo()
        }
      ),
    []
  )

  useEffect(
    () =>
      useEmulatorStore.subscribe(
        (state) => state.tripData,
        (tripData) => {
          tripDataRef.current = tripData
          updateStopWindowInfo()
        }
      ),
    []
  )

  useEffect(() => {
    updateStopWindowInfo()
  }, [props.selectedStop])
  function updateStopWindowInfo() {
    const stop = props.selectedStop
    console.log('XYZ updateStopWindowInfo')
    if (!connectedEmulatorRef.current || !tripDataRef.current || !stop) return
    let distanceToThisStopPoint = 0
    for (let i = 0; i < stop.tripPointIndex; i++) {
        if (i < 0) continue
        distanceToThisStopPoint += tripDataRef.current.tripPoints[i].distance
      }
      const distanceInMiles = (distanceToThisStopPoint * 0.000621371).toFixed(2)
      console.log('XYZ distanceToThisStopPoint', distanceToThisStopPoint)
      console.log('XYZ distanceInMiles', distanceInMiles)
      setDistanceFromStartToStops(distanceInMiles)
      const emulatorVelocity = connectedEmulatorRef.current.initialVelocity
      // find previous stops if any, add their waitTimes
      let extraWaitTime = 0
      for (let i = 0; i < tripDataRef.current.stops.length; i++) {
        if (tripDataRef.current.stops[i].tripPointIndex < props.selectedStop.tripPointIndex) {
          extraWaitTime += tripDataRef.current.stops[i].waitTime
        }
      }
      // do same for breaksV2
      for (let i = 0; i < tripDataRef.current.breaksV2.length; i++) {
        if (tripDataRef.current.breaksV2[i].tripPointIndex < props.selectedStop.tripPointIndex) {
          extraWaitTime += tripDataRef.current.breaksV2[i].waitTime
        }
      }
      console.log('XYZ extraWaitTime', extraWaitTime)
      console.log('XYZ distanceToThisStopPoint', distanceToThisStopPoint)
      console.log('XYZ emulatorVelocity', emulatorVelocity)
      console.log('XYZ tripDataRef.current.emulatorDetails.departTimeInUtc', connectedEmulatorRef.current.departTimeInUtc)
      // 1747480924721 //1747481958339
      const driveTimeToReachThisStop = connectedEmulatorRef.current.departTimeInUtc + ((distanceToThisStopPoint / emulatorVelocity) * 1000)
      console.log('XYZ driveTimeToReachThisStop', driveTimeToReachThisStop)
      const timeToReachThisStop = dayjs(driveTimeToReachThisStop + extraWaitTime).utcOffset(0).tz('America/Chicago').format('MMM D, YYYY, h:mm:ss A')
      setTimeToReachThisStop(timeToReachThisStop)
      console.log('XYZ stop wait time', stop.waitTime)
      const tripResumeTime = dayjs(driveTimeToReachThisStop + extraWaitTime + stop.waitTime).utcOffset(0).tz('America/Chicago').format('MMM D, YYYY, h:mm:ss A')
      setTripResumeTime(tripResumeTime)
      console.log('XYZ tripResumeTime', tripResumeTime)
  
      let emulatorDistanceToThisStop = 0
        console.log('XYZ tripDataRef.current.tripPoints[i]', tripDataRef.current)
        console.log('XYZ connectedEmulatorRef.current.currentTripPointIndex', connectedEmulatorRef.current.currentTripPointIndex)
      for (let i = connectedEmulatorRef.current.currentTripPointIndex; i < stop.tripPointIndex; i++) {
        if (i < 0) continue
        console.log('XYZ tripDataRef.current.tripPoints[i]', tripDataRef.current.tripPoints[i])
        emulatorDistanceToThisStop += tripDataRef.current.tripPoints[i].distance
      }
      const remainingDistanceToThisStop = (emulatorDistanceToThisStop * 0.000621371).toFixed(2) + ' miles'
      setRemainingDistanceToThisStop(remainingDistanceToThisStop)
      console.log('XYZ remainingDistanceToThisStop', remainingDistanceToThisStop)
    }

  const handleDeleteStopModal = () => {
    setDeleteStopsShow(!deleteStopsShow)
  }

  const handleClose = () => {
    setDeleteStopsShow(false)
  }

  const handleDeleteStop = async () => {
    // request on window for confirmation
    // if yes, delete stop
    // if no, do nothing

    // const shouldDelete = window.confirm(
    //   'Are you sure you want to delete this stop?'
    // )
    // if (!shouldDelete) {
    //   return
    // }
    showToast('Deleting stop...', 'info')
    const token = localStorage.getItem('token')
    const { success, error } = await ApiService.makeApiCall(
      TRIP_STOPS_DELETE_URL,
      'GET',
      null,
      token,
      connectedEmulatorRef.current?.id,
      new URLSearchParams({
        stopTripPointIndex: props.selectedStop.tripPointIndex
      })
    )
    if (!success) {
      showToast(error, 'error')
    } else {
      // setTripData(data); NOTE: THIS IS NOT NEEDED, THE SSE SHOULD BE ABLE TO RESPOND TO THIS CHANGE WITHIN 500 ms
      showToast('Stop deleted', 'success')
      props.handleInfoWindowClose()
      localStorage.setItem('click', false)
    }
    setDeleteStopsShow(false)
  }

  return (
    <>
      <InfoWindow
        position={{
          lat: props.selectedStop.lat,
          lng: props.selectedStop.lng
        }}
        onCloseClick={props.handleInfoWindowClose}
      >
        <div className="selectedStopBox">
          <div className="selectedStopInfo">
            <div className="container text-center">
              <div className="row">
                <div className="col-md-6">
                  {/* STOP ADDRESS HERE */}
                  <div className="mt-0 mb-4">
                    <h6 className="selectedStopHeader">Stop Address </h6>
                    <p
                      className="selectedStopPara"
                      style={{ textAlign: 'left !important' }}
                    >
                      {props.selectedStop.address.map((addressItem, index) => (
                        <React.Fragment key={index}>
                          {index > 0 && ', '}
                          {addressItem.long_name}
                        </React.Fragment>
                      ))}
                    </p>
                  </div>

                  {/* DISTANCE  */}

                  <div className="selectedStopInfo">
                    <div>
                      <h6>Distance from Start</h6>
                      <p>{distanceFromStartToStops + ' miles' || 'N/A'}</p>
                    </div>
                  </div>
                  {/* DISTANCE */}

                  {/* REMAINING DISTANCE */}

                  <div>
                    <h6>Remaining Distance from Start</h6>
                    <p>{remainingDistanceToThisStop || 'N/A'}</p>
                  </div>

                </div>
                <div className="col-md-6">
                  {/* NEAREST GAS STATION HERE */}
                  <div className="mb-4">
                    <h6>Nearest Gas Station</h6>
                    <p>
                      {props.selectedStop.gasStation.map(
                        (gasStationAddressItem, index) => (
                          <React.Fragment key={index}>
                            {index > 0 && ', '}
                            {gasStationAddressItem.long_name}
                          </React.Fragment>
                        )
                      )}
                    </p>
                  </div>

                  {/* TIME FOR ARRIVAL */}
                  <div className="mb-4">
                    <div>
                      <h6>Time for Arrival (CST)</h6>
                      <p>{timeToReachThisStop || 'N/A'}</p>
                    </div>
                  </div>

                  {/* TRIP RESUME TIME */}
                  <div className="mb-4">
                    <div>
                      <h6>Trip resume Time (CST)</h6>
                      <p>{tripResumeTime || 'N/A'}</p>
                    </div>
                  </div>
                  {/* Edit Button + Edit Component */}
                  {/* <EditableWaitingTimeComponent
                    tripPointIndex={props.selectedStop.tripPointIndex}
                    waitTime={props.selectedStop.waitTime}
                    connectedEmulatorId={connectedEmulatorRef.current?.id}
                    handleDeleteStop={handleDeleteStopModal}
                    handleClose={props.handleInfoWindowClose}
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </InfoWindow>

      {/* Delete Stop Modal */}
      <Dialog
        open={deleteStopsShow}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-description-title">
          Delete Stop
          {/* Close Button */}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: '#00000'
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description-desc">
            Are you sure you want to delete this stop?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            size="small"
            className="stops-delete-btn-modal"
            onClick={handleDeleteStop}
            autoFocus
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

function readableTime(time) {
  const date = new Date(time)
  const options = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
  }
  return date.toLocaleString('en-US', options)
}